<template>
  <a-form :form="form" id="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="Assignee">
          <a-select
            mode="multiple"
            placeholder="Please select"
            v-decorator="[
              'assignee_sppds',
              {
                rules: [{ required: true }],
                initialValue: initialData.assignee_sppds,
              },
            ]"
            @change="changeassignee"
          >
            <a-select-option
              showSearch
              v-for="user in getAllKaryawan"
              :key="user.tlc"
              >{{ user.tlc }} - {{ user.nama }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="Prospect No" v-if="initialData.jenis_anggaran=='07'">
            <a-select
              showSearch
              :allowClear="(getTlc_CEO==end_user ? true : false)"
              :not-found-content="null"
              option-filter-prop="children"
              v-decorator="[
                'prospek',
                {
                  rules: [{ required: (getTlc_CEO==end_user ? false : true) }], initialValue: initialData.prospek
                },
              ]"
            >
              <a-select-option
                v-for="item in listProspect"
                :key="item.id_prospek"
              >
                {{ item.no_prospek }} - {{ item.description }}
              </a-select-option>
            </a-select>
          </a-form-item>
        <a-form-item label="Work Unit">
          <a-input
            v-decorator="[
              'satuankerja_sppds',
              {
                rules: [{ required: true }],
                initialValue: initialData.satuankerja_sppds,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Address">
          <a-input
            v-decorator="[
              'alamat_sppds',
              {
                rules: [{ required: true }],
                initialValue: initialData.alamat_sppds,
              },
            ]"
          ></a-input>
        </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="Contact" :max="12">
          <a-input
            v-decorator="[
              'cp_sppds',
              {
                rules: [{ required: true }],
                initialValue: initialData.cp_sppds,
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Transportation">
          <a-select
            mode="multiple"
            v-decorator="[
              'transport_sppds',
              {
                rules: [{ required: true }],
                initialValue: initialData.transport_sppds,
              },
            ]"
          >
            <a-select-option
              v-for="transport in transportasi"
              :key="transport.value"
              >{{ transport.label }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="Accomodation">
          <a-select
            mode="multiple"
            v-decorator="[
              'akomodasi_sppds',
              {
                rules: [{ required: true }],
                initialValue: initialData.akomodasi_sppds,
              },
            ]"
          >
            <a-select-option v-for="data in akomodasi" :key="data.value">{{
              data.label
            }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

export default {
  props: {
    block: Object,
    data: {},
    pimpro_atasan: {},
    mode: String,
    id: String,
    informasi: Object,
  },
  name: "PerintahKerja",
  data() {
    return {
      form: this.$form.createForm(this),
      transportasi: [
        {
          value: "Rented Car",
          label: "Rented Car",
        },
        {
          value: "Company's Car",
          label: "Company's Car",
        },
        {
          value: "Bus",
          label: "Bus",
        },
        {
          value: "Train",
          label: "Train",
        },
        {
          value: "Ship",
          label: "Ship",
        },
        {
          value: "Airplane",
          label: "Airplane",
        },
        {
          value: "Other",
          label: "Other",
        },
      ],
      akomodasi: [
        {
          value: "Hotel",
          label: "Hotel",
        },
        {
          value: "Company's Resident",
          label: "Company's Resident",
        },
        {
          value: "Rented House",
          label: "Rented House",
        },
        {
          value: "Other",
          label: "Other",
        },
      ],
      dataValid: {},
      listProspect:[],
      end_user_sppds: null
    };
  },
  mounted() {
    Event.$on("perintahkerja", this.isValidate);
    if(this.informasi && this.informasi.jenis_anggaran=='07'){
      this.getProspectList(this.informasi.cost_center);
    }
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
  },
  computed: {
    ...mapGetters(["getAllKaryawan", "getAuth", "getTlc_CEO"]),
    initialData: function () {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          assignee_sppds: [],
          satuankerja_sppds: "",
          alamat_sppds: "",
          cp_sppds: "",
          transport_sppds: [],
          akomodasi_sppds: [],
          jenis_anggaran: this.informasi.jenis_anggaran,
          prospek: ''
        };
      } else {
        return {
          assignee_sppds: this.data.assignee_sppds,
          satuankerja_sppds: this.data.satuankerja_sppds,
          alamat_sppds: this.data.alamat_sppds,
          cp_sppds: this.data.cp_sppds,
          transport_sppds: this.data.transport_sppds,
          akomodasi_sppds: this.data.akomodasi_sppds,
          jenis_anggaran: this.informasi.jenis_anggaran,
          prospek: this.data.prospek
        };
      }
    },
    end_user(){
      return this.end_user_sppds ? this.end_user_sppds : null
    }
  },
  methods: {
    clearForm() {
      this.form.resetFields();
    },
    getBOD(param) {
      return new Promise((resolve, reject) => {
        axios({
          method: "Post",
          url: this.$serviceUrl + "sppds/check_and_get_directur",
          data: {
            assignee_sppds: param,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async checkBOD(param) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: this.$serviceUrl + "sppds/check_bod_on_revisi",
          data: {
            id_sppd: this.id,
            assignee_sppds: param,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          console.log(err);
          return;
        }
        // this.dataValid = [{ perintahkerja: values }, { status: true }];
        Event.$emit("handleLoadingNext", true);
        if (this.mode === "Edit") {
          this.checkBOD(values.assignee_sppds).then(
            (result) => {
              if (result.data.status === undefined) {
                this.displayMessageValue("error-other", "Data Error");
              } else if (result.data.status === false) {
                Event.$emit("handleLoadingNext", false);
                this.displayMessageValue("error-other", result.data.message);
              } else {
                this.handleBOD(values);
              }
            },
            (error) => {
              Event.$emit("handleLoadingNext", false);             
              let response = Object.assign({}, error.response.data);
              if (response.status === false) {
                this.displayMessageValue("error-other", response.message);
              }else{
                this.displayMessageValue("error-other", error);
              }
            }
          );
        } else {
          this.handleBOD(values);
        }
      });
    },
    handleBOD(values) {
      Event.$emit("handleLoadingNext", true);
      this.getBOD(values.assignee_sppds).then(
        (result) => {
          let dataResult;
          // dataResult = {
          //   status: true,
          //   anybod: false,
          //   direktur: [
          //     {
          //       value: "ADI",
          //       text: "Johanes Adi Sasongko",
          //     },
          //     {
          //       value: "BGS",
          //       text: "Bagoes Soediarto",
          //     },
          //     {
          //       value: "ROC",
          //       text: "Rocky Fentara",
          //     },
          //   ],
          // };
          dataResult = result.data;
          try {
            if (dataResult.status === undefined) {
              this.displayMessageValue("error-other", "Data Error");
            } else {
              Event.$emit("collectData", {
                perintahkerja: values,
                bod: dataResult,
              });
            }
            Event.$emit("handleLoadingNext", false);
          } catch (err) {
            Event.$emit("handleLoadingNext", false);
            this.displayMessageValue("error-other", err);
          }
        },
        (error) => {
          Event.$emit("handleLoadingNext", false);
          this.displayMessageValue("error-other", error);
        }
      );
    },
    handleRefBackPerintahKerja() {
      this.form.validateFields((err, values) => {
        if (err) {
          console.log(err);
          return;
        }
        Event.$emit("collectDataBackPerintahKerja", { perintahkerja: values });
      });
    },
    async getProspectList(e){
      await axios({
        method: "get",
        url: this.$serviceUrl + "prospek/pilih_prospek",
        params: {
          anggaran_id: e
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then(async (response) => {
        this.listProspect = await (response.data.data ? response.data.data : []);
      })
      .catch(() => {
      });
    },
    changeassignee(val){
      let ceo_assign = val.filter(item=>item==this.getTlc_CEO)
      this.end_user_sppds = ceo_assign.length>0 ? ceo_assign[0] : ''
    }
  },
};
</script>
